if($('footer#footer').length){
    $('.top-navigation-bar .container').append($('footer#footer .contact-box').clone())
    $('footer#footer .custom-top .top-right').prepend($('footer#footer .contact-box .cellphone').clone(), $('footer#footer .contact-box .mail').clone())
    $('.top-navigation-bar .container, header#header .header-top .container').append($('footer#footer .custom-top').clone())
    $('.footer-bottom .container').append($('footer#footer .doprava-platba'))
    $('.sledujte-nas, .sledujte-socialni-site .right').append($('footer#footer .contact-box .social-icon-list').clone())
    $('.call-us .tel').append($('footer#footer .contact-box .cellphone').clone())
    $('.call-us .email').append($('footer#footer .contact-box .mail').clone())
    $('.in-index footer#footer').before($('footer#footer .custom-footer__newsletter').wrapInner('<div class="container"></div>'))
}
else{
    $('.top-navigation-bar .container').append('<div class="contact-box" data-testid="contactbox"></div>')
    if (!sessionStorage.contact_info) {
        $(document).on("ready", function(){
          $(".top-navigation-bar .contact-box").load("/ footer#footer .contact-box", function(){
            sessionStorage.contact_info = $(".top-navigation-bar .contact-box").html();
          });
        })
      } else {
        $(".top-navigation-bar .contact-box").append(sessionStorage.contact_info);
      };
}